"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Input = _interopRequireDefault(require("@micado-digital/react-form/Input"));
var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));
var _de = _interopRequireDefault(require("../../../../locals/de.json"));
var _en = _interopRequireDefault(require("../../../../locals/en.json"));
var _it = _interopRequireDefault(require("../../../../locals/it.json"));
var _ProductSelectionContext = _interopRequireDefault(require("../../../../ProductDetail/context/ProductSelectionContext"));
var _Message = _interopRequireDefault(require("./Message.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Message = _ref => {
  let {
    lang
  } = _ref;
  const {
    productSelection = {},
    setProductSelection
  } = (0, _react.useContext)(_ProductSelectionContext.default);
  const {
    message
  } = productSelection;
  const css = (0, _Message.default)();
  const l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      it: _it.default
    }
  });
  const handleChange = e => {
    setProductSelection(prevProductSelection => ({
      ...prevProductSelection,
      message: e.target.value
    }));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.message, "mco-shop-product-detail-voucher-selection-message")
  }, /*#__PURE__*/_react.default.createElement(_Input.default, {
    label: l("reactShop.productDetail.labels.message"),
    name: "message",
    value: message,
    TextfieldProps: {
      minRows: 5,
      multiline: true,
      variant: "outlined",
      onChange: handleChange,
      inputProps: {
        maxLength: 250
      }
    }
  }));
};
var _default = exports.default = Message;